import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-30345dce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content-wrapper" }
const _hoisted_2 = { class: "content-header" }
const _hoisted_3 = { class: "container-fluid" }
const _hoisted_4 = { class: "content mt-5" }
const _hoisted_5 = {
  key: 0,
  class: "content__loading-icon"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-circle-notch fa-spin fa-6x" }, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "loading-content" }
const _hoisted_9 = { class: "card" }
const _hoisted_10 = { class: "card-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "header", {}, undefined, true)
      ])
    ]),
    _createElementVNode("section", _hoisted_4, [
      _createElementVNode("div", {
        class: _normalizeClass(["container-fluid", _ctx.appendClass])
      }, [
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, _hoisted_7))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _renderSlot(_ctx.$slots, "content", {}, undefined, true)
            ])
          ])
        ])
      ], 2)
    ])
  ]))
}